export default __webpack_public_path__ + "static/media/dsdinternationalacademy.88474c74.png";